import { motion } from "framer-motion";

const CRAFT_IMG = "/cnc-craft.jpg";

const STEPS = [
  {
    num: "01",
    title: "Consultation & Measure",
    desc: "We visit your home, listen to how you use the space, and take exact measurements. No obligation, no pressure.",
  },
  {
    num: "02",
    title: "Design & Materials",
    desc: "Detailed drawings and 3D visuals with timber, finish and hardware samples you can see and touch before we cut a single board.",
  },
  {
    num: "03",
    title: "Precision CNC Production",
    desc: "Your cabinetry is produced on high-precision CNC machines — every panel, hinge hole and edge machined to the millimetre for a flawless fit, every time.",
  },
  {
    num: "04",
    title: "Fitting & Aftercare",
    desc: "Our own fitters install everything, scribe to your walls and leave the room spotless. Every piece carries a 10-year guarantee.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-24 lg:py-32 bg-espresso-900">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <p className="section-label" data-testid="process-label">How We Work</p>
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-cream mt-4" data-testid="process-heading">
            From first sketch to <span className="italic text-brass">final fitting</span>
          </h2>
        </motion.div>
        <div className="mt-12 space-y-0">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`process-step-${i}`}
              className="border-t border-espresso-600 py-8 flex gap-6"
            >
              <span className="font-serif text-2xl text-brass shrink-0 w-12">{s.num}</span>
              <div>
                <h3 className="font-serif text-xl text-cream">{s.title}</h3>
                <p className="text-sm text-cream-muted leading-relaxed mt-2 max-w-md">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="relative">
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:sticky lg:top-28 border border-espresso-600"
        >
          <img
            src={CRAFT_IMG}
            alt="The Golden Mile Interiors CNC machine in the Delacombe workshop"
            className="w-full aspect-[4/3] object-cover"
          />
          <div className="absolute bottom-0 inset-x-0 bg-[#120E0B]/85 backdrop-blur-md border-t border-espresso-600 px-6 py-4">
            <p className="text-[10px] tracking-[0.25em] uppercase text-brass">The Workshop</p>
            <p className="text-xs text-cream-muted mt-1">Every commission is CNC-machined in our own workshop — never subcontracted.</p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
